var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-box"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s("美式vibe风裤子高街潮ins设计感满印提花牛仔裤复古hiphop直筒裤"))]),(_vm.productType)?_c('div',{staticClass:"desc"},[_vm._v("类型："+_vm._s(_vm.productType || '暂无'))]):_vm._e(),_c('shareMovable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }